// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__rkx1m","comment":"styles_comment__14j5U"};